const Main = () => import ('../views/main/main.vue')
const btnIndex = () => import ('@/views/kfgl/btnIndex')
const menuIndex = () => import ('@/views/kfgl/menuIndex')
const tableIndex = () => import ('@/views/kfgl/tableIndex')
const fieldList = () => import ('@/views/kfgl/fieldList')
const tablekey = () => import ('@/views/kfgl/tablekey')
const formIndex = () => import ('@/views/kfgl/formIndex')
const addForm = () => import ( '@/views/kfgl/addForm')
const flexIndex = () => import ('@/views/kfgl/flexIndex')
const flexcolForm = () => import ('@/views/kfgl/flexcolForm')
const docgenIndex = () => import ('@/views/kfgl/docgenIndex')
const docgencolForm = () => import ('@/views/kfgl/docgencolForm')
const syscodeIndex = () => import ( '@/views/kfgl/syscodeIndex')
const lhcIndex = () => import ('@/views/kfgl/lhcIndex')
const lhcForm = () => import ('@/views/kfgl/lhcForm')
const methodIndex = () => import ('@/views/kfgl/methodIndex')
const doctIndex = () => import ('@/views/kfgl/doctIndex')
const doctForm = () => import ('@/views/kfgl/doctForm')
const browsIndex = () => import ('@/views/kfgl/browsIndex')
const browsForm = () => import ('@/views/kfgl/browsForm')
const browscolForm = () => import ('@/views/kfgl/browscolForm')
const clearData = () => import ('@/views/kfgl/clearData')
const unitIndex = () => import ('@/views/kfgl/unitIndex')
const cosIndex = () => import ('@/views/kfgl/cosIndex')
const cosForm = () => import ('@/views/kfgl/cosForm')
const roleIndex = () => import ('@/views/kfgl/roleIndex')
const roleAuthForm = () => import ( '@/views/kfgl/roleAuthForm')
const roleAuthReport = () => import ('@/views/kfgl/roleAuthReport')
const logManagement = () => import ('@/views/kfgl/logManagement')


export default [{
  path: '/kfgl',
  component: Main,
  redirect: '',
  meta: {
    title: '开发管理',
    icon: 'guide'
  },
  children: [
    {
      path: 'btnIndex',
      component: btnIndex,
      name: 'btnIndex',
      meta: { title: '按钮管理', keepAlive: true }
    },
    {
      path: 'menuIndex',
      component: menuIndex,
      name: 'menuIndex',
      meta: { title: '菜单管理', keepAlive: true }
    },
    {
      path: 'tableIndex',
      component: tableIndex,
      name: 'tableIndex',
      meta: { title: '数据字典', keepAlive: true }
    },
    {
      path: 'fieldList',
      component: fieldList,
      name: 'fieldList',
      meta: { title: '字段清单', keepAlive: true }
    },
    {
      path: 'tablekey',
      component: tablekey,
      name: 'tablekey',
      meta: { title: '表键', keepAlive: true }
    },
    {
      path: 'formIndex',
      component: formIndex,
      name: 'formIndex',
      meta: { title: '表单管理', keepAlive: true }
    },
    {
      path: 'addForm',
      component: addForm,
      name: 'addForm',
      meta: { title: '新增表单', keepAlive: true }
    },
    {
      path: 'flexIndex',
      component: flexIndex,
      name: 'flexIndex',
      meta: { title: '表格管理', keepAlive: true }
    },
    {
      path: 'flexcolForm',
      component: flexcolForm,
      name: 'flexcolForm',
      meta: { title: '表格列设置', keepAlive: true }
    },
    {
      path: 'docgenIndex',
      component: docgenIndex,
      name: 'docgenIndex',
      meta: { title: '单据生成定义', keepAlive: true }
    },
    {
      path: 'docgencolForm',
      component: docgencolForm,
      name: 'docgencolForm',
      meta: { title: '单据生成列定义', keepAlive: true }
    },
    {
      path: 'syscodeIndex',
      component: syscodeIndex,
      name: 'syscodeIndex',
      meta: { title: '系统代码', keepAlive: true }
    },
    {
      path: 'lhcIndex',
      component: lhcIndex,
      name: 'lhcIndex',
      meta: { title: '物流码', keepAlive: true }
    },
    {
      path: 'lhcForm',
      component: lhcForm,
      name: 'lhcForm',
      meta: { title: '物流码维护', keepAlive: true }
    },
    {
      path: 'methodIndex',
      component: methodIndex,
      name: 'methodIndex',
      meta: { title: '单号生成方法', keepAlive: true }
    },
    {
      path: 'doctIndex',
      component: doctIndex,
      name: 'doctIndex',
      meta: { title: '单据分类', keepAlive: true }
    },
    {
      path: 'doctForm',
      component: doctForm,
      name: 'doctForm',
      meta: { title: '单据分类维护', keepAlive: true }
    },
    {
      path: 'browsIndex',
      component: browsIndex,
      name: 'browsIndex',
      meta: { title: '数据助手', keepAlive: true }
    },
    {
      path: 'browsForm',
      component: browsForm,
      name: 'browsForm',
      meta: { title: '数据助手维护', keepAlive: true }
    },
    {
      path: 'browscolForm',
      component: browscolForm,
      name: 'browscolForm',
      meta: { title: '数据字段维护', keepAlive: true }
    },
    {
      path: 'clearData',
      component: clearData,
      name: 'clearData',
      meta: { title: '测试数据清理', keepAlive: true }
    },
    {
      path: 'unitIndex',
      component: unitIndex,
      name: 'unitIndex',
      meta: { title: '计量单位', keepAlive: true }
    },
    {
      path: 'cosIndex',
      component: cosIndex,
      name: 'cosIndex',
      meta: { title: '平台管理', keepAlive: true }
    },
    {
      path: 'cosForm',
      component: cosForm,
      name: 'cosForm',
      meta: { title: '子平台维护', keepAlive: true }
    },
    {
      path: 'roleIndex',
      component: roleIndex,
      name: 'roleIndex',
      meta: { title: '角色资料', keepAlive: true }
    },
    {
      path: 'roleAuthForm',
      component: roleAuthForm,
      name: 'roleAuthForm',
      meta: { title: '角色授权功能', keepAlive: true }
    },
    {
      path: 'roleAuthReport',
      component: roleAuthReport,
      name: 'roleAuthReport',
      meta: { title: '角色授权报表', keepAlive: true }
    },
    {
      path: 'logManagement',
      component: logManagement,
      name: 'logManagement',
      meta: { title: '日志查询', keepAlive: true }
    }
  ]
}
]
